export const isRoutePublic = () => {
  const pathname = window.location.pathname?.split("/") || [];

  return pathname[1] === "public" || pathname[1] === "p";
};
